import React, { createContext, useState, useCallback } from 'react';
import { CommunicationTool } from '../chat-api';

export interface AppContextTypes {
  isLoading: boolean;
  setIsLoading(state: any): void;
  initialMessage: string;
  setInitialMessage(state: any): void;
  isAnonymous: boolean;
  setIsAnonymous(state: any): void;
  showAttendant: boolean;
  setShowAttendant(state: any): void;
  communicationTool: CommunicationTool;
  setCommunicationTool(state: any): void;
  translationBundle: TranslationBundle;
  setTranslationBundle(state: any): void;
  getTranslation(key: string, args?: any[]): string;
  hasVideo: boolean;
  setHasVideo(state: any): void;
  showAvatar: boolean;
  setShowAvatar(state: any): void;
  responsiveMode: boolean;
  setResponsiveMode(state: any): void;
}

export interface TranslationBundle {
  [key: string]: string;
}

export const AppContext = createContext<AppContextTypes>(null!);

const AppContextProvider: React.FC = React.memo(({children}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [initialMessage, setInitialMessage] = useState<string>(null!);
  const [showAttendant, setShowAttendant] = useState<boolean>(false);
  const [hasVideo, setHasVideo] = useState<boolean>(false);
  const [isAnonymous, setIsAnonymous] = useState<boolean>(false);
  const [communicationTool, setCommunicationTool] = useState<CommunicationTool>(null!);
  const [translationBundle, setTranslationBundle] = useState<TranslationBundle>({});
  const [showAvatar, setShowAvatar] = useState<boolean>(false);
  const [responsiveMode, setResponsiveMode] = useState<boolean>(false);

  const getTranslation = useCallback((key: string, args?: any[]) => {
    let unit = translationBundle[key];
    if (unit && args && args.length) {
      args.forEach((param, index) => {
        unit = unit.replace(`{${index}}`, param.replace(/\$/gi, "$$$$"));
      });
    }
    return unit || key
  }, [translationBundle]);

  const contextState: AppContextTypes = {
    isLoading,
    setIsLoading,
    initialMessage,
    setInitialMessage,
    showAttendant,
    isAnonymous,
    setIsAnonymous,
    setShowAttendant,
    communicationTool,
    setCommunicationTool,
    translationBundle,
    setTranslationBundle,
    getTranslation,
    hasVideo,
    setHasVideo,
    showAvatar,
    setShowAvatar,
    responsiveMode,
    setResponsiveMode
  };

  return (
    <AppContext.Provider value={contextState}>
      {children}
    </AppContext.Provider>
  );
})


export default AppContextProvider;